// extracted by mini-css-extract-plugin
module.exports = {"showcolor":"style_showcolor__2AyrJ","splayer":"style_splayer__2nD7q"};